import { render, staticRenderFns } from "./LoadingCop.vue?vue&type=template&id=1c47b9b8&scoped=true&"
import script from "./LoadingCop.vue?vue&type=script&lang=js&"
export * from "./LoadingCop.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCop.vue?vue&type=style&index=0&id=1c47b9b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47b9b8",
  null
  
)

export default component.exports